import {
  BeneficiaryDetailsCurrency,
  BeneficiaryTransferDestination,
  USDBeneficiaryOptions,
} from 'types/beneficiaries'
import { ContactFiatInstrumentFormKeys } from '../schemas/contactFiatInstrumentSchema'
import { Step, Steps } from '../types/fiatInstruments'

export const isAddressFieldsRequired = ({
  currency,
  transferDestination,
  paymentMethod,
}: {
  currency?: string
  transferDestination?: string
  paymentMethod?: string
}) => {
  const isSwift = transferDestination === BeneficiaryTransferDestination.INTERNATIONAL
  const isLocalAchOrFedwire =
    transferDestination === BeneficiaryTransferDestination.LOCAL &&
    currency === BeneficiaryDetailsCurrency.USD &&
    paymentMethod !== USDBeneficiaryOptions.CUBIX

  return isSwift || isLocalAchOrFedwire
}

export const getFieldsToValidate = (step: Step): ContactFiatInstrumentFormKeys[] => {
  const basicFields: ContactFiatInstrumentFormKeys[] = [
    'transferDestination',
    'entityType',
    'description',
    'currency',
    'paymentReference',
    'beneficiaryAddressLine1',
    'beneficiaryAddressLine2',
    'beneficiaryCity',
    'beneficiaryRegion',
    'beneficiaryPostCode',
    'beneficiaryCountryCode',
  ]

  const basicBankAccountFields: ContactFiatInstrumentFormKeys[] = [
    'beneficiaryBankName',
    'accountNumber',
    'bankCode',
    'routingNumber',
    'accountType',
    'paymentMethod',
  ]
  const bankAddressFields: ContactFiatInstrumentFormKeys[] = [
    'bankName',
    'bankCountryName',
    'bankAddressLine1',
    'bankAddressLine2',
    'bankCity',
    'bankRegion',
    'bankPostCode',
    'bankCountryCode',
  ]
  const intermediaryBankFields: ContactFiatInstrumentFormKeys[] = [
    'intermediaryBankCode',
    'intermediaryBankRoutingNumber',
    'intermediaryBankName',
    'intermediaryBankAddressLine1',
    'intermediaryBankAddressLine2',
    'intermediaryBankCity',
    'intermediaryBankRegion',
    'intermediaryBankPostCode',
    'intermediaryBankCountryCode',
  ]

  switch (step) {
    case Steps.LOCAL_BANK_DETAILS:
      return [...basicFields, ...basicBankAccountFields]
    case Steps.INTERNATIONAL_BANK_DETAILS:
      return [
        ...basicFields,
        ...basicBankAccountFields,
        ...bankAddressFields,
        ...intermediaryBankFields,
      ]
    case Steps.INTERMEDIARY_BANK_DETAILS:
      return intermediaryBankFields

    default:
      return []
  }
}
